import React from 'react';
import image1 from '../assets/operaCharitas.png';
import image2 from '../assets/caRezzonico.jpg';

export default function Banner() {
    return (
        <div style={styles.container} className='bannerShadow'>
            <div style={{...styles.imageContainer, borderRight: '2px solid white'}}>
                <img src={image1} alt="1" style={styles.image}/>
            </div>
            <div style={{...styles.imageContainer, borderLeft: '2px solid white'}}>
                <img src={image2} alt="2" style={styles.image}/>
            </div>
        </div>
    );
};

const styles = {
    container: {
        width: '100vw',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 0,
        margin: 0,
        // gap: '4px',
        backgroundColor: 'white'
    },
    imageContainer: {
        width: '50%',
        display: 'flex',
        padding: 0,
        margin: 0,
        borderLeft: '1px solid black',
    },
    image: {
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
    }
}